import { render } from "./ParticipantPage.vue?vue&type=template&id=28f4ca76&ts=true"
import script from "./ParticipantPage.vue?vue&type=script&lang=ts"
export * from "./ParticipantPage.vue?vue&type=script&lang=ts"

import exportComponent from "/home/jenkins/agent/workspace/IT_CICD/SDK/Prod/Joymeet_frontend/GUI/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__